import { Component, OnInit } from '@angular/core';
// import {MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-dashboard-contact-info',
  templateUrl: './dashboard-contact-info.component.html',
  styleUrls: ['./dashboard-contact-info.component.scss']
})
export class DashboardContactInfoComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<DashboardContactInfoComponent>) { }

  ngOnInit(): void {
  }

}
